import { CSSObjectWithLabel, GroupBase, StylesConfig } from "react-select";
import React from "react";
import { MultiOption } from "./MultiSelect";

const multiSelectStyles = (
    error: unknown,
    touched: unknown
): StylesConfig<MultiOption, true, GroupBase<MultiOption>> => {
    return {
        container: (provided: CSSObjectWithLabel) => ({
            ...provided,
            height: "100%",
            maxHeight: "49px",
        }),

        control: (provided: CSSObjectWithLabel, state) => {
            const defaultBorderColor = state.isFocused ? "#ACA1DF" : "#DEDEDE";
            const borderColor = touched && error ? "#DC3545" : defaultBorderColor;
            return {
                ...provided,
                borderColor: borderColor,
                padding: "6px 0px",
                borderRadius: "4px",
                minHeight: "100%",
                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(111, 66, 193, 0.25)" : "none",
                "&:hover": {
                    borderColor: "#ACA1DF",
                },
            };
        },

        valueContainer: (provided: CSSObjectWithLabel) => ({
            ...provided,
            flexWrap: "wrap",
            rowGap: 6,
            columnGap: 8,
            maxHeight: 72,
            overflowY: "auto",
            padding: "0 4px",
        }),

        option: (
            provided: CSSObjectWithLabel,
            { isSelected, isFocused }: { isSelected: Boolean; isFocused: boolean }
        ) => ({
            ...provided,
            borderRadius: "4px",
            marginBottom: "8px",
            padding: "7px 8px",
            cursor: "pointer",
            backgroundColor: isSelected ? "#F9F8FD" : isFocused ? "#F7F7FD" : "#FFFFFF",
            color: "#1F3354",
            "& .option-color": {
                color: isSelected ? "#5842BE" : "#9D9D9D",
            },
            "&:hover": {
                backgroundColor: "#f5f5f5",
                color: "#5842BE",
                "& .option-color": {
                    color: "#5842BE",
                },
            },
        }),

        placeholder: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
            color: "#9D9D9D",
            margin: "0px 4px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        }),

        input: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
            color: "#1F3354",
        }),

        dropdownIndicator: (provided: CSSObjectWithLabel, { selectProps }: any) => ({
            ...provided,
            transform: selectProps.menuIsOpen ? "rotate(180deg)" : null,
            transition: "transform 0.2s ease",
            color: "#1F3354",
            padding: "8px 12px",
            display: "flex",
        }),

        menu: (provided: CSSObjectWithLabel) => ({
            ...provided,
            marginTop: "4px",
            zIndex: "600",
        }),

        menuList: (provided: CSSObjectWithLabel) => ({
            ...provided,
            padding: "12px",
        }),

        indicatorSeparator: () => ({
            display: "none",
        }),

        singleValue: (provided: CSSObjectWithLabel) => ({
            ...provided,
            fontSize: "14px",
        }),

        multiValue: (provided: CSSObjectWithLabel) => ({
            ...provided,
            backgroundColor: "#EEECF8",
            color: "#5842BE",
            marginRight: 0,
            marginBottom: 0,
            marginTop: 0,
            borderRadius: 4,
        }),

        multiValueLabel: (provided: CSSObjectWithLabel) => ({
            ...provided,
            color: "#5842BE",
            fontSize: "14px",
            padding: "4px 6px",
        }),

        multiValueRemove: (provided: CSSObjectWithLabel) => ({
            ...provided,
            ":hover": {
                backgroundColor: "#5842BE",
                color: "#FFFFFF",
            },
        }),

        clearIndicator: (provided: CSSObjectWithLabel) => ({
            ...provided,
            display: "none",
        }),

        menuPortal: (provided: CSSObjectWithLabel) => ({
            ...provided,
            zIndex: 1060,
        }),
    };
};
export default multiSelectStyles;
